import { Link } from 'react-router-dom';

export default function FinalCTA({
  eyebrow = 'Ready to talk through your project?',
  title = "Let's put a real estimate together.",
  body = 'Share project details, photos, and a preferred timeline. We\'ll review the scope and get back to you within 24 hours.',
}) {
  return (
    <section className="surface-dark text-brand-bone" data-testid="final-cta">
      <div className="container-x py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-12 items-start">
        <div>
          <div className="eyebrow text-brand-maroonBright mb-3">{eyebrow}</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">{title}</h2>
          <p className="mt-6 font-sans text-base lg:text-lg text-brand-bone/75 max-w-xl leading-relaxed">{body}</p>
        </div>
        <div className="lg:pt-6 flex flex-col gap-3 sm:flex-row lg:flex-col lg:items-end">
          <Link to="/estimate" className="btn-primary" data-testid="final-cta-estimate">
            Request an Estimate
          </Link>
          <Link to="/gallery" className="btn-ghost-dark" data-testid="final-cta-gallery">
            View Completed Projects
          </Link>
        </div>
      </div>
    </section>
  );
}
